import React from 'react';
import Footer from './Footer';
import Header from './Header';

const PageWrapper = ({children}) => {
    return (
        <div>
            <Header/>
            <div style={{height:"100vh", overflow:"scroll"}}>
                <div className="container app-content">
                    {children}
                </div> 
                <Footer/>
            </div>
        </div>
    );
};

export default PageWrapper;